/* eslint-disable consistent-return */
import axios from 'axios';
import { API_ROOT } from '../config/appConfig';
import { getHeaders } from '../actions/helper.action';

export const getInstitutionListApi = async (jwt) => {
  try {
    const res = await axios.get(
      `${API_ROOT}/user-management/admin/institutions`,
      getHeaders('application/json', jwt)
    );

    if (res.status === 200) {
      return res.data;
    }
  } catch (err) {
    console.error(err);
  }
};
